import * as React from "react"
import { useDraggable } from "@dnd-kit/core"
import { Paper, Box } from "@mui/material"

const DragHandleContext = React.createContext(null);

export function useDragHandle() {
    const context = React.useContext(DragHandleContext);
    if (!context) {
        throw new Error("useDragHandle must be used within a DraggableResizableContent");
    }
    return context;
}

export default function DraggableResizableContent({
    id,
    children,
    position,
    open,
    width = '600px',
    height = '400px'
}) {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({ id })
    
    if (!open) return null;

    const x = position.x + (transform?.x ?? 0)
    const y = position.y + (transform?.y ?? 0)

    return (
        <Paper
            ref={setNodeRef}
            elevation={8}
            sx={{
                position: 'fixed',
                zIndex: 1300, 
                transform: `translate3d(${x}px, ${y}px, 0)`,
                resize: 'both',
                overflow: 'hidden',
                minWidth: '300px',
                minHeight: '200px',
                maxWidth: '100vw',
                maxHeight: '100vh',
                left: 0,
                top: 0,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper'
            }}
            style={{
                width: width,
                height: height
            }}
        >
            <DragHandleContext.Provider value={{ attributes, listeners }}>
                {children}
            </DragHandleContext.Provider>
        </Paper>
    )
}
